<script lang="ts">
    import { _ } from "svelte-i18n";
</script>

<section class="pt-8 pt-md-11 mb-6">
    <div class="container">
        <div class="row justify-content-center pb-4">
            <div class="col-12 col-md-10 col-lg-8 text-center">
                <!-- Heading -->
                <h2 class="font-weight-bold">
                    {$_("blog.newsletter.stay")} <a
                        href="https://www.anyways.eu/contact/">{$_("blog.newsletter.intouch")}</a
                    >.
                </h2>

                <!-- Text -->
                <p class="font-size-lg text-muted">
                    {$_("blog.newsletter.description")}
                </p>
            </div>
        </div>
        <!-- / .row -->
        <div class="row justify-content-center">
            <div class="col-12 col-md-6 col-lg-6">
                <!-- Form -->
                <form
                    action="//anyways.us14.list-manage.com/subscribe/post?u=f1fd1c0efb76d15b4df9d90a7&amp;id=2fc9864079"
                    method="post"
                    id="mc-embedded-subscribe-form"
                    name="mc-embedded-subscribe-form"
                    class="validate form-inline"
                    novalidate>
                    <div style="position: absolute; left: -5000px;">
                        <input
                            type="text"
                            name="b_80eaa86e948880d8e05720a98_a489708aef"
                            tabindex="-1"
                            value="" />
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-7">
                            <div class="form-group">
                                <!-- Input -->
                                <input
                                    type="email"
                                    value=""
                                    name="EMAIL"
                                    class="form-control required email"
                                    id="mce-EMAIL"
                                    required
                                    data-validation-required-message="{$_("blog.newsletter.email.message")}"
                                    placeholder="{$_("blog.newsletter.email.placeholder")}" />
                            </div>
                        </div>
                        <div class="col-auto">
                            <!-- Submit -->
                            <button
                                type="submit"
                                value="Subscribe"
                                name="subscribe"
                                id="mc-embedded-subscribe"
                                class="btn btn-primary lift">
                                {$_("blog.newsletter.submit")}
                            </button>
                        </div>
                    </div>
                    <!-- / .row -->
                    <div class="row" />
                    <!-- / .row -->
                </form>
            </div>
            <div class="row justify-content-center pt-8">
                <div class="col-12 col-md-10 col-lg-8 text-center">
                    <!-- Text -->
                    <p class="font-size-lg text-muted mb-7 mb-md-9" />
                </div>
            </div>
        </div>
    </div>
</section>
